import { Box } from "@mui/material";
import React from "react";

export default function Section({ children }) {
  return <Box sx={{ pt: 3 }}>{children}</Box>;
}
